module.exports = __webpack_public_path__ + "img/bitgerthero.5d61bfc7.png";